import { referrerActions } from '@/redux/modules';
import * as Styles from './ReferrerFriend.styles';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import useLocale from '@/hooks/useLocale';
import Loader from '@/components/Layout/Loader';
import FaqReferrer from '@/components/FrequentlyQuestions/FaqReferrer';
import HowItWorks from './HowItWorks';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FOXTROT_REFER_EARN } from '@/config/GrowthBook/constants';

const ReferrerFriend = () => {
  const { referrerFriend: referrerLocale } = useLocale();
  const [accordionsOpened, setAccordionsOpened] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const { routes: routesLocale } = useLocale();
  const extoleJwt = useSelector(state => state.referrer.extoleJwt);
  const hasError = extoleJwt && extoleJwt.error;
  const isLoading = extoleJwt && extoleJwt.loading;
  const enableReferEarn = useFeatureIsOn(FOXTROT_REFER_EARN);

  const callGetExtoleJwt = useCallback(() => {
    dispatch(referrerActions.referrer.extoleJwt.get());
  }, [dispatch]);

  useEffect(() => {
    if (hasError || !enableReferEarn) {
      history.push(routesLocale.home);
    }
  }, [hasError, history, routesLocale, enableReferEarn]);

  useEffect(() => {
    if (!extoleJwt.value && enableReferEarn) {
      callGetExtoleJwt();
    }
  }, [callGetExtoleJwt, extoleJwt.value, enableReferEarn]);

  useEffect(() => {
    const handleExtoleMessage = (event) => {
      // eslint-disable-next-line no-console
      console.log('[Extole] message received:', event.data);
    };

    window.addEventListener('message', handleExtoleMessage);
    return () => window.removeEventListener('message', handleExtoleMessage);
  }, []);

  if (isLoading) {
    return <Loader data-testid="loader" />;
  }

  return (
    <Styles.Wrapper data-testid="referrer-friend">
      <Styles.ExtoleIframe scrolling="no" src={`https://indique-um-amigo.hostgator.com.br/zones/account_page_embedded_experience?extole_jwt=${extoleJwt.value}`} />
      <HowItWorks
        title={referrerLocale.howItWorks.title}
        linkLabel={referrerLocale.howItWorks.linkLabel}
        linkUrl={referrerLocale.howItWorks.linkUrl}
        steps={referrerLocale.howItWorks.steps}
      />
      <FaqReferrer
        title={referrerLocale.faq.title}
        faqItems={referrerLocale.faq.items}
        accordionsOpened={accordionsOpened}
        setAccordionsOpened={setAccordionsOpened}
      />
    </Styles.Wrapper>
  );
};

export default ReferrerFriend;
